import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '../client';
import { toast } from 'react-hot-toast';

interface NewsletterResponse {
    success: boolean;
    message?: string;
    data?: any;
}

export const useNewsletter = () => {
    return useMutation({
        mutationFn: async (email: string) => {
            const response = await api.post<NewsletterResponse>('/api/newsletter/subscribe', { email });
            return response.data;
        },
        onSuccess: (data) => {
            if (data.success) {
                toast.success('Successfully subscribed to newsletter!');
            } else {
                toast.success(data.message || 'Already subscribed');
            }
        },
        onError: (error: any) => {
            toast.error(error.response?.data?.error || 'Failed to subscribe to newsletter');
        }
    });
};

export interface NewsletterSubscriber {
    id: string;
    email: string;
    active: boolean;
    createdAt: string;
    updatedAt: string;
}



export const useNewsletterSubscribers = () => {
    return useQuery<NewsletterSubscriber[]>({
        queryKey: ['newsletter-subscribers'],
        queryFn: async () => {
            // api.get<T> unwraps the response, so T should be the type of the 'data' field
            const response = await api.get<NewsletterSubscriber[]>('/api/admin/newsletter');
            if (!response.data) throw new Error('No data received');
            return response.data;
        }
    });
};
